import useGetCurriculumCountryCodeForURL, {
  getCurriculumCountryCodeWithGradePrefix,
} from '~/curriculum/hooks/useGetCurriculumCountryCode'
import useSsrSafeValue from '~/hooks/useSsrSafeValue'
import ROUTES from '~/shared/constants/routes.const'

export function getSelectGradePageRoute(config: {
  isOnboarding?: boolean
  countryCodeWithGradePrefix: string
}): string {
  return config.isOnboarding
    ? `${ROUTES.ONBOARDING}/v2/${config.countryCodeWithGradePrefix}/select-grade`
    : `${ROUTES.CURRICULUM}/v2/${config.countryCodeWithGradePrefix}/select-grade`
}

export default function useGetGradePageRoute(config?: {
  isOnboarding?: boolean
  specificCountryCode?: string
}): string {
  const countryCodeWithGradePrefix = useGetCurriculumCountryCodeForURL(config?.specificCountryCode)
  return getSelectGradePageRoute({ isOnboarding: config?.isOnboarding, countryCodeWithGradePrefix })
}

// The route the server renders: it has no `curriculumCountry` cookie.
export function getServerGradePageRoute(config?: { isOnboarding?: boolean; specificCountryCode?: string }): string {
  return getSelectGradePageRoute({
    isOnboarding: config?.isOnboarding,
    countryCodeWithGradePrefix: getCurriculumCountryCodeWithGradePrefix(config?.specificCountryCode ?? ''),
  })
}

// Use for rendered hrefs only. Redirects (useRedirectV1PageToV2) must keep
// useGetGradePageRoute — they fire on mount and need the real country code immediately.
export function useGetGradePageRouteForLink(config?: { isOnboarding?: boolean; specificCountryCode?: string }): string {
  const route = useGetGradePageRoute(config)
  return useSsrSafeValue(getServerGradePageRoute(config), route)
}
